"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChallengeCardData = ChallengeCardData;
var _Skeleton2 = _interopRequireDefault(require("@mui/material/Skeleton"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _moment = _interopRequireDefault(require("moment"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _ = require("..");
var _environment = require("../../environment");
var _hooks = require("../../hooks");
var _progressionDescription = require("./progression-description");
var _progressionHighlight = require("./progression-highlight");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const now = (0, _moment.default)();
function ChallengeCardData({
  Button,
  Dialog,
  containerProps,
  geogroup,
  challenge,
  event,
  enableMembersCount,
  disableDaysCount,
  disableProgression,
  enableUserProgression,
  enableProgressionHighlight: _enableProgressionHighlight,
  enableProgressionDescription,
  userChallenge
}) {
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    getFormattedProgressValue
  } = (0, _hooks.useChallenge)();
  const {
    toOrdinal,
    toDistance
  } = (0, _hooks.useUnits)();
  const startDate = challenge?.startDate;
  const endDate = challenge?.endDate;
  const sameYear = startDate && endDate && startDate.get('year') === endDate.get('year');
  const sameMonthAndYear = sameYear && startDate.get('month') === endDate.get('month');
  const from = startDate?.format(sameMonthAndYear ? 'DD' : sameYear || startDate.get('year') === now.get('year') ? 'DD MMMM' : 'DD MMMM YYYY');
  const to = endDate?.format(endDate.get('year') === now.get('year') ? 'DD MMMM' : 'DD MMMM YYYY');
  const teamLeaderboard = challenge?.collaborationType === 'teams' && userChallenge && userChallenge.subgroupsLeaderboards?.find(({
    subGroupType
  }) => subGroupType === challenge.subGroupDisplay) || null;
  const enableProgressionHighlight = challenge && challenge.period === 'future' ? false : _enableProgressionHighlight || false;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 3
  }, ((!challenge || 'nbMembers' in challenge) && enableProgressionHighlight || event && (event.isPublic || event.dedicatedWebsiteUrl)) && /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 1
  }, (!challenge || 'nbMembers' in challenge) && enableProgressionHighlight && /*#__PURE__*/_react.default.createElement(_progressionHighlight.ChallengeCardProgressionHighlight, {
    challenge: challenge,
    enableUserProgression: enableUserProgression,
    teamLeaderboard: teamLeaderboard,
    userChallenge: userChallenge
  }), event && (event.isPublic || event.dedicatedWebsiteUrl) && /*#__PURE__*/_react.default.createElement(_Box2.default, {
    bgcolor: "#F3F6FF",
    borderRadius: 2,
    display: "flex",
    flexDirection: "column",
    gap: 1,
    padding: 2
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "body2"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    components: [/*#__PURE__*/_react.default.createElement("a", {
      href: event.dedicatedWebsiteUrl || `${_environment.defaultEnvironment.eventsSiteUrl}${event.id}`,
      key: 0,
      rel: "noreferrer",
      style: {
        color: '#326ac2'
      },
      target: "_blank"
    })],
    i18nKey: "commons.challenges.display_all_leaderboards",
    values: {
      url: (event.dedicatedWebsiteUrl || `${_environment.defaultEnvironment.eventsSiteUrl}${event.id}`).replace('https://', '').replace('http://', '')
    }
  })))), (event?.sponsor || challenge?.sponsor) && /*#__PURE__*/_react.default.createElement(_Box2.default, {
    paddingX: 2
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontStyle: "italic",
    variant: "body2"
  }, t('commons.challenges.sponsored_by', {
    sponsor: event?.sponsor || challenge?.sponsor
  }))), /*#__PURE__*/_react.default.createElement(_Box2.default, _extends({
    display: "flex",
    flexDirection: "column",
    gap: 2
  }, containerProps), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    gap: 1
  }, /*#__PURE__*/_react.default.createElement(_.CalendarIcon, {
    color: challenge ? 'primary' : 'action',
    fontSize: "small"
  }), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column"
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "body2"
  }, challenge ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, disableDaysCount || challenge.daysLeft < 0 ? t('commons.periods.from_to', {
    from,
    to
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, challenge.daysToWait > 0 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, t('commons.challenges.days_to_wait', {
    count: challenge.daysToWait
  })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, t('commons.challenges.days_left', {
    count: challenge.daysLeft
  })))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 100
  }))), challenge && !disableDaysCount && challenge.daysLeft >= 0 && challenge.daysToWait <= 0 && /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "textSecondary",
    variant: "caption"
  }, t('commons.periods.from_to', {
    from,
    to
  })))), (!challenge || challenge.type !== 'noTarget') && /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    gap: 1
  }, /*#__PURE__*/_react.default.createElement(_.CupIcon, {
    color: challenge ? 'primary' : 'action',
    fontSize: "small"
  }), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column"
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "body2"
  }, challenge ? challenge.type === 'traveledDistance' ? t('commons.challenges.types.distance_description', {
    context: challenge.targetValue ? challenge.collaborationType : `${challenge.collaborationType}_no_target`,
    distance: toDistance(challenge.targetValue)
  }) : challenge.type === 'cyclingDays' ? t('commons.challenges.types.cycling_days_description', {
    context: challenge.collaborationType,
    count: challenge.targetValue
  }) : t('commons.challenges.types.journeys_description', {
    context: challenge.collaborationType,
    count: challenge.targetValue
  }) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 100
  })), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "textSecondary",
    variant: "caption"
  }, challenge ? challenge.traceType === 'commuting' || challenge.type === 'homeWorkJourneysCount' ? t('commons.challenges.types.considered_journeys_home_work') : t('commons.challenges.types.considered_journeys_all') : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 100
  })))), (!challenge || 'nbMembers' in challenge) && enableMembersCount && /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    gap: 1
  }, /*#__PURE__*/_react.default.createElement(_.PeopleIcon, {
    color: challenge ? 'primary' : 'action',
    fontSize: "small"
  }), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "body2"
  }, challenge ? t(_.challengeCollaborationTypesMap[challenge.collaborationType === 'global' ? 'individual' : challenge.collaborationType].labelKey) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 100
  }))), !disableProgression && !enableProgressionHighlight && (!challenge || challenge.period !== 'future' && 'nbMembers' in challenge && (challenge.targetValue || enableUserProgression) && (challenge.collaborationType !== 'teams' || teamLeaderboard)) && /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    gap: 1
  }, /*#__PURE__*/_react.default.createElement(_.CupIcon, {
    color: challenge ? 'primary' : 'action',
    fontSize: "small"
  }), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column"
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "body2"
  }, challenge ? challenge.collaborationType === 'teams' ? teamLeaderboard && t('commons.challenges.rank_team_short', {
    count: teamLeaderboard.countSubgroupOfSameType,
    rank: toOrdinal(teamLeaderboard.rank, {
      feminine: true
    })
  }) : userChallenge?.rank ? t('commons.challenges.rank_short', {
    count: challenge.nbMembers,
    rank: toOrdinal(userChallenge.rank, {
      inclusive: true
    })
  }) : getFormattedProgressValue(challenge) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 100
  })), challenge?.period === 'past' && /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "body2"
  }, t('commons.challenges.well_done')))))), (!challenge || challenge.period !== 'future' && (challenge.collaborationType === 'global' || enableUserProgression)) && enableProgressionDescription && /*#__PURE__*/_react.default.createElement(_progressionDescription.ChallengeCardProgressionDescription, {
    Button: Button,
    Dialog: Dialog,
    geogroup: geogroup
  }));
}